// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 获取当前的用户 GET /api/currentUser */
export async function currentUser(options?: { [key: string]: any }) {
  return request<{
    data: API.CurrentUser;
  }>('/auth/me', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/auth/logout', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 登录接口 POST /api/login/account */
// export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
//   return request<API.LoginResult>('/auth/login', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     data: body,
//     ...(options || {}),
//   });
// }

/** 旧登录接口（兼容） */
export async function login(body: API.LoginParams) {
  // 转换为 x-www-form-urlencoded 格式
  const formData = new URLSearchParams();
  body.username && formData.append('username', body.username);
  body.password && formData.append('password', body.password);

  return request<API.LoginResult>('/auth/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: formData.toString(),
  });
}

/** 账号登录接口 POST /auth/login/username */
export async function loginByUsername(body: { username: string; password: string }) {
  return request<API.LoginResult>('/auth/login/username', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
  });
}

/** 账号登录（带手机号辅助验证） POST /auth/login/username-with-phone */
export async function loginByUsernameWithPhone(body: { username: string; password: string; phone: string }) {
  return request<API.LoginResult>('/auth/login/username-with-phone', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
  });
}

/** 手机号登录接口 POST /auth/login/phone */
export async function loginByPhone(body: { phone: string; password: string }) {
  return request<API.LoginResult>('/auth/login/phone', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
  });
}

/** 刷新 token 接口 POST /auth/refresh */
export async function refreshToken(refresh_token: string) {
  return request<API.LoginResult>('/auth/refresh', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: { refresh_token },
    // 跳过错误处理，避免循环刷新
    skipErrorHandler: true,
    // 跳过自动添加 token，避免使用过期的 access_token
    skipToken: true,
  });
}

/** 更新当前用户个人信息 PUT /auth/me */
export async function updateProfile(data: {
  email?: string;
  full_name?: string;
  avatar?: string;
  phone?: string;
}) {
  return request<API.ApiResult>('/auth/me', {
    method: 'PUT',
    data,
  });
}

/** 修改密码 POST /auth/change-password */
export async function changePassword(data: {
  old_password: string;
  new_password: string;
}) {
  return request<{
    success: boolean;
    message: string;
    require_relogin?: boolean;
    reason?: string;
  }>('/auth/change-password', {
    method: 'POST',
    data,
  });
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}

